"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duplicateLayer = void 0;
const Printable_1 = require("../../models/printables/Printable");
const either_1 = require("../../types/either");
const findPrintableGroup_1 = require("./findPrintableGroup");
const printables_1 = require("../printables");
const helpers_1 = require("./addEditableTextLayer/helpers");
const EditableTextLayer_1 = require("../../models/layers/EditableTextLayer");
const createEditableTextLayer_1 = require("./addEditableTextLayer/createEditableTextLayer");
const duplicateLayer = (project, action) => {
  const printable = (0, findPrintableGroup_1.findPrintableInProject)(project, action.printableId);
  if (!printable) {
    return (0, either_1.left)(new Error(`Could not find printable for project ${project.id}`));
  }
  const layerToDuplicate = (0, printables_1.findLayerInPrintable)(printable, action.layerId);
  if (!layerToDuplicate) {
    return (0, either_1.left)(new Error(`Could not find printable for project ${project.id}`));
  }
  if (!(0, EditableTextLayer_1.isEditableTextLayer)(layerToDuplicate)) {
    return (0, either_1.left)(new Error(`Only editable_text layers can be duplicated. LayerId: ${layerToDuplicate.id}`));
  }
  const interiorPrintableGroupIndex = project.printableGroups.findIndex(p => p.type === 'interior');
  if (interiorPrintableGroupIndex < 0) {
    return (0, either_1.left)(new Error(`Could not find interior printable group for project ${project.id}`));
  }
  const printableIndex = project.printableGroups[interiorPrintableGroupIndex].printables.findIndex(p => p.id === action.printableId);
  if (printableIndex < 0) {
    return (0, either_1.left)(new Error(`Could not find printable for project ${project.id}`));
  }
  const {
    x,
    y,
    width,
    height
  } = layerToDuplicate;
  const existingTextLayers = (0, helpers_1.getEditableTextLayersInPrintable)(printable);
  const {
    newX,
    newY
  } = (0, helpers_1.findFirstAvailableSlot)(existingTextLayers, x, y, layerToDuplicate);
  const newEditableTextLayerData = {
    designId: printable.designId,
    x: newX,
    y: newY,
    width,
    height,
    zIndex: (0, helpers_1.getMaxZIndex)(printable),
    existingTextLayers,
    baseLayer: layerToDuplicate
  };
  const newEditableTextLayer = (0, createEditableTextLayer_1.createEditableTextLayer)(newEditableTextLayerData);
  const newPrintable = (0, Printable_1.updatePrintableVersion)(printable, action.timestamp);
  newPrintable.layers.push(newEditableTextLayer);
  project.printableGroups[interiorPrintableGroupIndex].printables[printableIndex] = newPrintable;
  const updatedEntities = [project, newPrintable];
  return (0, either_1.right)({
    updatedProject: project,
    updatedEntities: updatedEntities
  });
};
exports.duplicateLayer = duplicateLayer;